import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { TRecommendation } from '../../types/recommendation';
import { getMobileRecommendations, getDesktopRecommendations } from '../../services/getRecommendations';
import { IAppState, IApplicationContext } from '../../types';
import { ELoadingStatus } from '../../types/loadingStatus';

const initialState = {
  data: [] as TRecommendation[],
  status: ELoadingStatus.Loading,
};

const createFetchRecommendationsAsyncThunk = createAsyncThunk.withTypes<{
  state: IAppState;
  extra: IApplicationContext;
}>();

export const fetchRecommendations = createFetchRecommendationsAsyncThunk(
  'recommendations/fetch',
  (_, { getState, extra: context }) => {
    const {
      custom: { isMobile },
    } = context;
    const { regionId, landingType } = getState();

    const getRecommendations = isMobile ? getMobileRecommendations : getDesktopRecommendations;

    return getRecommendations(context, { parameters: { regionId, landingType } });
  },
);

const recommendationsSlice = createSlice({
  name: 'recommendations',
  reducers: {},
  initialState,
  extraReducers(builder) {
    builder.addCase(fetchRecommendations.pending, state => {
      state.status = ELoadingStatus.Loading;
    });
    builder.addCase(fetchRecommendations.fulfilled, (state, { payload }) => {
      state.status = ELoadingStatus.Success;
      state.data = payload;
    });
    builder.addCase(fetchRecommendations.rejected, state => {
      state.status = ELoadingStatus.Failure;
    });
  },
});

export const recommendationsReducer = recommendationsSlice.reducer;
